// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import fetch from './utils/fetch'
import store from './store/index'
import fileconfig from './utils/common'

import lodash from 'lodash'
Vue.prototype.lodash = lodash
import qs from 'qs'
Vue.prototype.$qs = qs

// import 'lib-flexible/flexible'
import Swiper from 'swiper'
import 'swiper/dist/css/swiper.min.css'

import 'element-ui/lib/theme-chalk/index.css'

import './element-variables.scss'

import '../src/assets/style/reset.css'
import '../static/fonts/iconfont.css'

import VueVideoPlayer from 'vue-video-player'

import 'video.js/dist/video-js.css' // 引入样式

import 'vue-video-player/src/custom-theme.css' // 引入样式

import 'videojs-flash'
ElementUI.Dialog.props.closeOnClickModal.default = false
ElementUI.MessageBox.setDefaults({
  closeOnClickModal: false,
})
Vue.use(VueVideoPlayer)

Vue.prototype.$http = fetch
Vue.config.productionTip = false
// 创建全局bus对象 用于兄弟组件传值
Vue.prototype.bus = new Vue()
Vue.use(ElementUI)

import HomeHeader from '@/components/HomeHeader.vue'
Vue.component('HomeHeader', HomeHeader)

const messages = ['success', 'warning', 'info', 'error']

messages.forEach(type => {
  ElementUI.Message[type] = options => {
    if (typeof options === 'string') {
      options = {
        message: `<span style='font-size:22px;'>${options}</span>`,
      }
      // 默认配置
      options.dangerouslyUseHTMLString = true
      options.offset = 400
      options.duration = 3000
      options.showClose = false
      options.center = true
    }
    options.type = type

    return ElementUI.Message(options)
  }
})
import Sticky from 'vue-sticky-directive'
Vue.use(Sticky)
Vue.prototype.$fileapi = `${fileconfig.fileUrl + fileconfig.coverapi}`
/* eslint-disable no-new */
const vm = new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
})
console.log('vm', vm.$fileapi)



// WEBPACK FOOTER //
// ./src/main.js